import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
// Assuming Modal.module.css exists in ../../styles
import styles from '../../styles/Modal.module.css'; 
import { useAtlasStore, AtlasState } from '../../../../store/atlasStore'; // Import store

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void; // Callback for confirmation
  title: string; // Title for the modal
  message: string; // Confirmation message/question
  confirmText?: string; // Text for the confirm button (e.g., "Delete")
  cancelText?: string; // Text for the cancel button
  isConfirming?: boolean; // Optional flag to show loading state on confirm button
  variant?: 'primary' | 'destructive'; // Add variant prop
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ 
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isConfirming = false,
  variant = 'primary', // Default to primary
}) => {
  const setSparkUserInteractionBlockingRefresh = useAtlasStore((state: AtlasState) => state.setSparkUserInteractionBlockingRefresh);

  // Effect to block/unblock background refresh
  useEffect(() => {
    if (isOpen) {
        setSparkUserInteractionBlockingRefresh(true);
        return () => {
            setSparkUserInteractionBlockingRefresh(false);
        };
    }
  }, [isOpen, setSparkUserInteractionBlockingRefresh]);

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} data-modal-root="true">
      <div className={styles.modalContent}>
        <h2>{title}</h2>
        <p style={{ whiteSpace: 'pre-line' }}>{message}</p>

        <div className={styles.modalActions}>
          <button onClick={onClose} disabled={isConfirming} className={styles.buttonSecondary}>
            {cancelText}
          </button>
          <button 
            onClick={onConfirm} 
            disabled={isConfirming}
            className={`${styles.buttonPrimary} ${variant === 'destructive' ? styles.buttonDestructive : ''}`}
          >
            {isConfirming ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}; 
